import { diffWords } from "diff"
import { useState } from "react";
import { Link, useLoaderData } from "react-router";
import PostMarkdown from "../components/PostMarkdown";
import NotFound from "./NotFound";
import { EditorButton } from "../components/EditorButton";

function HistoryDiff() {
    const { revision, before: lastRevision } = useLoaderData();
    const [showingDiff, changeDiffState] = useState(false)
    
    if (revision == null) return <NotFound />

    function HistoryNav({ revision }: { revision: Record<string, any> }) {
        return <>
            <div className='text-white font-semibold block p-2 px-4 bg-orange-500 w-[calc(100%_+_2rem)] -m-4 mb-4'>
                This is an old revision of this page, edited by {`@${revision.user.username}`} at {new Date(revision.created_at).toDateString()}. <Link className="text-primary font-semibold" to={`/${revision.article_path}`}>Click here to view the current article</Link>
            </div>
            <div className="*:border-r-2 *:border-r-primary *:pr-2 mb-2">
                <Link
                    className={
                        (revision.revisions.before == undefined ? "text-outline pointer-events-none" : "text-primary")
                    }
                    to={revision.revisions.before !== undefined ? `/history/preview/${revision.revisions.before}` : ""}
                    children="Last revision"
                />
                <Link
                    className={
                        "mx-2 " +
                        (revision.revisions.next == undefined ? "text-outline pointer-events-none" : "text-primary")
                    }
                    to={revision.revisions.next !== undefined ? `/history/preview/${revision.revisions.next}` : ""}
                    children="Next revision"
                />
                {revision.revisions.before !== undefined && <Link
                    className="border-none text-primary"
                    to={""}
                    onClick={() => changeDiffState(state => !state)}
                    children="Preview difference with previous revision"
                />}
            </div>
        </>
    }


    if (showingDiff && lastRevision) {
        const diff = diffWords(lastRevision.content, revision.content)
        return <>
            <HistoryNav revision={revision} />
            <div>
                <h2 className='text-3xl font-semibold mb-2'>{revision.title}</h2>
                {diff.map((part, index) => (
                    <span
                        key={index}
                        style={{
                            backgroundColor: part.added ? "lightgreen" : part.removed ? "salmon" : "transparent",
                        }}
                    >
                        {part.value.split("\n").map((text, index) => {
                            const split = part.value.split("\n")
                            return <div key={index} style={{ display: "inline" }}>
                                <span>{text}</span>
                                {(split.length > 1 && index < (split.length - 1)) && <br />}
                            </div>
                        })}
                    </span>
                ))}
            </div>
        </>
    }

    return <>
        <HistoryNav revision={revision} />
        <div className='flex flex-row-reverse items-center justify-between flex-wrap mb-3'>
            <div>
                <EditorButton src='/images/rewind.png' label='View history' to={`/history/${revision["article_id"]}`} />
            </div>
            <h2 className='text-3xl font-semibold mb-2'>{revision.title}</h2>
        </div>
        <PostMarkdown
            body={revision.content || ""}
        />
    </>
}

export default HistoryDiff